import { HttpMethod } from './http-method';

export class ApiAction {
  httpMethod: HttpMethod | null = null;
  params: {} | null = null;
  url: string[] | null = null;
  payload: any | null;
}
